angular.module("app")
	.directive("okinaMap", ["leafletData", "OkinaLeafletService", function (leafletData, OkinaLeafletService) {
		return {
			restrict: "E",
			templateUrl: "common/directives/map/okinaMap.html",
			scope: {
				height: "=",
				width: "=",
				mapId: "=",
				mapLegend: "=",
				overlayInstitutionVisibility: "=",
				overlayCitiesVisibility: "=",
				measureMode: "="
			},
			controller: function ($scope) {
				OkinaLeafletService.addWidget($scope, {
					type: "address-search",
					position: "topleftright",
					bar: true,
					large: true
				});

				if ($scope.measureMode !== false) {
					OkinaLeafletService.addDrawControls({
						draw: {
							polygon: false,
							marker: false,
							polyline: true,
							rectangle: false,
							circle: false,
							circlemarker: false,
						},
						drawSimpleLine: true
					},
					OkinaLeafletService.calculateRoutePolyline,
					() => {
						return OkinaLeafletService.getMap().then(map => {
							map.eachLayer(layer => {
								if (layer.options.id === OkinaLeafletService.RULE_POLYLINE
									|| (layer.options.properties && layer.options.properties.id === OkinaLeafletService.RULE_POLYLINE)) {
									OkinaLeafletService.removeShapeGeoJson(layer);
								}
							});
						})
					},
					"Mesurer une distance",
					$scope);
				}

				$scope.layers = {
					baselayers: {
						atlas: {
							name: "Atlas",
							url: "https://{s}.tile.thunderforest.com/atlas/{z}/{x}/{y}.png?apikey=0d925ffb1c7f4fa29c090405b4038b96",
							type: "xyz"
						},

					}
				};
				$scope.controls = {
					fullscreen: {
						position: "topleft"
					}
				};

				$scope.defaults = {
					controls: {
						layers: {
							visible: true,
							position: "bottomleft",
							collapsed: false
						}
					}
				};
			},

			link: function ($scope) {
				$scope.mapWidth = $scope.width != null ? $scope.width : "100%";
				$scope.mapHeight = $scope.height != null ? $scope.height : "500px";
				$scope._mapLegend = $scope.mapLegend || {visible: false};

				OkinaLeafletService.getMap().then(map => {
					L.tileLayer("", {
						attribution: "Carte &copy; <a href=\"https://www.thunderforest.com/\">Thunderforest</a>," +
							" Données cartographiques &copy; <a href=\"https://www.openstreetmap.org/copyright\">OpenStreetMap contributors</a>"
					}).addTo(map);
				});

				$scope.$watch("overlayInstitutionVisibility", function (newValue, oldValue) {
					if (oldValue !== newValue) {
						OkinaLeafletService.directiveProperties.overlays.institutions.display = newValue;
					}
				});

				$scope.$watch("overlayCitiesVisibility", function (newValue, oldValue) {
					if (oldValue !== newValue) {
						OkinaLeafletService.directiveProperties.overlays.cities.display = newValue;
					}
				});
			}
		};
	}]
	);
